import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    flex: 1,
    backgroundColor: '#004878',
    '&:hover': {
      backgroundColor: '#001f3f',
    },
  },
  label: {
    color: '#FFFFFF',
    textTransform: 'uppercase',
    fontSize: '14pt',
  },
});

interface ButtonProps {
  children: any;
  type?: any;
  [x: string]: any;
}

const PrimaryButton = (props: ButtonProps) => {
  const { children, ...other } = props;
  const classes = useStyles();
  return (
    <Button
      classes={{
        root: classes.root, // class name, e.g. `classes-nesting-root-x`
        label: classes.label, // class name, e.g. `classes-nesting-label-x`
      }}
      {...other}
    >
      {children || ''}
    </Button>
  );
};

export default PrimaryButton;
